module.exports = __webpack_public_path__ + "img/bg.8d38383f.png";